import { getUserProperty } from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import FetchError, { ValidationError } from '@atlassian/jira-fetch/src/utils/errors.tsx';
import {
	DEFAULT_JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE,
	JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY,
} from '../constants.tsx';
import type { AnnouncementDismissState } from './types.tsx';

type Parameters = {
	accountId: string;
};

export async function getAnnouncementDismissState({
	accountId,
}: Parameters): Promise<AnnouncementDismissState> {
	try {
		const response = await getUserProperty<AnnouncementDismissState>(
			accountId,
			JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY,
		);

		if (!response || typeof response !== 'object') {
			fireErrorAnalytics({
				meta: {
					id: 'getUserProperty',
					packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
					teamName: '50cent',
				},
				error: new ValidationError(
					'User property is not an object. It must be changed outside of the automated flow.',
				),
				sendToPrivacyUnsafeSplunk: true,
			});
			return DEFAULT_JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE;
		}

		if (
			!Object.keys(DEFAULT_JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE).every((key) =>
				Object.prototype.hasOwnProperty.call(response, key),
			)
		) {
			// If missing properties occur we are making sure they are filled in from the defaults
			return { ...DEFAULT_JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE, ...response };
		}

		return response;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		if (error instanceof FetchError && error.statusCode === 404) {
			return DEFAULT_JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE;
		}
		fireErrorAnalytics({
			meta: {
				id: 'getAnnouncementDismissState',
				packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
				teamName: '50cent',
			},
			error,
		});
	}
}
